// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0f90334d","895":"6a1e496e","909":"59152878"}[chunkId] + ".chunk.js";
};